export const environment = {
  production: false,
  apiUrl: 'https://app.crescioengine.com',
  whatsappNumber: '573000000000',
  whatsappMessage: 'Hola Crescio Engine, quiero información sobre un proyecto de software.',
};
